import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { getAgentApiToken } from '../utils/GetAccountDetails';
import { useAppContext } from '../context/AppContext';

function ExtractionTraining({ document_type_id, document_type, file_id, setPreviewMode }) {
    const { selectedOrganization, selectedProject } = useAppContext();

    const [loading, setLoading] = useState(true);
    const [agentTokenId, setAgentTokenId] = useState(null);
    const [pluginReady, setPluginReady] = useState(false);

    const iframeRef = useRef(null);

    const training_plugin_url = window.__ENV__.EXTRACTION_TRAINING_PLUGIN_URL;
    const appflyte_backend_url = window.__ENV__.APPFLYTE_BACKEND_URL;
    const appflyte_project_id = selectedProject?.payload?.__auto_id__;
    const appflyte_organization_id = selectedOrganization?.payload?.__auto_id__;

    useEffect(() => {
        const fetchToken = async () => {
            try {
                const token = await getAgentApiToken();
                setAgentTokenId(token);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchToken();
    }, []);

    const pluginInitData = useMemo(() => {
        if (!agentTokenId || !appflyte_project_id || !appflyte_organization_id) {
            return null;
        }

        return {
            appflyte_backend_url,
            appflyte_agent_api_token: agentTokenId,
            appflyte_organization_id,
            appflyte_project_id,
            extraction_document_type_id: document_type_id,
            extraction_document_type: document_type,
            extraction_file_id: file_id,
        };
    }, [
        agentTokenId,
        appflyte_project_id,
        appflyte_organization_id,
        document_type_id,
        document_type,
        file_id,
        appflyte_backend_url,
    ]);

    useEffect(() => {
        const handleMessage = (event) => {
            // if (event.origin !== training_plugin_url) return;

            if (event.data?.type === "PLUGIN_READY") {
                console.log("Plugin ready");
                setPluginReady(true);
            }

            if (event.data?.type === "PLUGIN_BACK_CLICKED") {
                setPreviewMode("document");
            }
        };
        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, []);

    useEffect(() => {
        if (!pluginReady || !pluginInitData) return;
        iframeRef.current?.contentWindow?.postMessage(
            {
                type: "PLUGIN_INIT",
                payload: pluginInitData
            },
            training_plugin_url
        );
    }, [pluginReady, pluginInitData]);

    if (loading || !agentTokenId) {
        return (
            <Box
                sx={{
                    backgroundColor: '#FFFFFF',
                    borderRadius: '20px',
                    height: '100%',
                    overflowY: 'auto',
                    padding: '20px',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        flexDirection: 'column',
                        gap: 2,
                    }}
                >
                    {loading ? (
                        <>
                            <CircularProgress sx={{ color: '#007bff' }} />
                            Loading please wait...
                        </>
                    ) : (
                        'No token available. Please try again.'
                    )}
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={{ height: "100vh", width: "100%" }}>
            <iframe
                ref={iframeRef}
                src={training_plugin_url}
                title="Ameya Plugin"
                style={{ width: "100%", height: "100%", border: "none" }}
            />
        </Box>
    );
}

export default ExtractionTraining;
